export const PROMOTION_ACTION = {
  registration: "registration",
  firstDeposit: "first_deposit",
  secondDeposit: "second_deposit",
};

export interface IPromoFieldFetch {
  country: string;
  action?: string;
  ended?: boolean;
}

export type PromoType = {
  id: string;
  title: string;
  description?: string;
  image?: string;
  country: string;
  game?: string;
  wager: number;
  freespins?: number;
  daysExpire: number;
  minDeposit: number;
  maxBonus: number;
  bonus: number;
  bonusPercent: number;
  ended: boolean;
  startAt: Date;
  endAt: Date;
};

export type UserPromoType = {
  promotion: PromoType;
  totalBet: number;
  bonus: number;
  freespins?: number;
  deposit: boolean;
  active: boolean;
  ended: boolean;
  endAt: Date;
};

export interface IPromoProps {
  country: string;
  isOpen: boolean;
  onClose: () => void;
  promoId: string | null;
  setPromoId: (id: string | null) => void;
}

export interface IPromo {
  id: string;
  title: string;
  description: string;
  rate: string;
  maxBonus: number;
  minDeposit: number;
  wager: number;
  imgSrc: string;
}

export interface IPromoCardProps {
  promo: IPromo;
  promoId?: string | null;
  onActivePromo: (value: string | null) => void;
  onMoreDetail: (value: IPromo | null) => void;
  country: string;
}

export type UserAcceptRequestType = {
  promoId?: string;
};

export type UserPromoAcceptType = {
  success: boolean;
};

export type UserChangeRequestType = {
  promoId?: string;
};
